import { Injectable } from '@angular/core';
import { SettingsService } from '../settings.service';
import { Response } from '@angular/http';
import { HttpResponse, HttpClient } from '@angular/common/http';
import { ComentarioOcorrencia } from '../comum/modelos/comentario-ocorrencia';
import { ConfigOcorrenciaAuto } from '../comum/modelos/config-ocorrencia-auto';
import { Ocorrencia } from '../comum/modelos/ocorrencia';
import { StatusOcorrencia } from '../comum/modelos/status-ocorrencia';
import { TipoOcorrencia } from '../comum/modelos/tipo-ocorrencia';
import { Observable } from 'rxjs/Observable';
import { FiltroOcorrencia } from '../comum/modelos/filtro-ocorrencia';
import { ResultadoOcorrencias } from '../comum/modelos/resultado-ocorrencias';
import { ResultadoOcorrenciaDiaria } from '../comum/modelos/resultado-ocorrencia-diaria';
import { ControleOcorrenciaAuto } from '../comum/modelos/controle-ocorrencia-auto';
import { ReincidenciaOcorrencia } from '../comum/modelos/reincidencia-ocorrencia';
import { CriterioReincidenciaOcorrencia } from '../comum/modelos/criterio-reincidencia-ocorrencia';
import { FiltroReincidencia } from '../comum/modelos/filtro-reincidencia';
import { Reincidencia } from '../comum/modelos/reincidencia';
import { EmailOcorrencia } from '../comum/modelos/email-ocorrencia';

@Injectable()
export class OcorrenciasService {

  private _host: string;

  constructor(
    private _settingsService: SettingsService,
    private _http: HttpClient) {
    this._host = this._settingsService.obterHostBase() + '/ocorrencias/';
  }

  obterAgendamentosOcorrenciaAutoHttp(id: number): Observable<ConfigOcorrenciaAuto[]> {
    return this._http.get(this._host + 'agendamento-ocorrencia-auto/cliente/' + id)
      .catch(this.handleError);
  }

  obterAgendamentoOcorrenciaAutoHttp(id: number): Observable<ConfigOcorrenciaAuto> {
    return this._http.get(this._host + 'agendamento-ocorrencia-auto/' + id)
      .catch(this.handleError);
  }

  cadastrarConfigOcorrenciaAutoHttp(configOcorrencia: ConfigOcorrenciaAuto): Observable<HttpResponse<ConfigOcorrenciaAuto>> {
    return this._http
      .post(this._host + 'agendamento-ocorrencia-auto/', configOcorrencia, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  atualizarConfigOcorrenciaAutoHttp(configOcorrencia: ConfigOcorrenciaAuto): Observable<HttpResponse<ConfigOcorrenciaAuto>> {
    return this._http
      .put(this._host + 'agendamento-ocorrencia-auto/', configOcorrencia, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  apagarConfigOcorrenciaAutoHttp(id: number): Observable<HttpResponse<ConfigOcorrenciaAuto>> {
    return this._http
      .delete(this._host + 'agendamento-ocorrencia-auto/' + id)
      .catch(this.handleError);
  }

  cadastrarOcorrenciaHttp(ocorrencia: Ocorrencia, foto: File): Observable<HttpResponse<Ocorrencia>> {
    const formdata: FormData = new FormData();
    formdata.append('imagem', foto);
    formdata.append('ocorrencia', new Blob([JSON.stringify(ocorrencia)], {
      type: 'application/json'
    }));
    return this._http
      .post(this._host, formdata, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterOcorrenciaHttp(id: number): Observable<Ocorrencia> {
    return this._http.get(this._host + id)
      .catch(this.handleError);
  }

  obterStatusOcorrenciaHttp(id: number): Observable<StatusOcorrencia> {
    return this._http.get(this._host + 'status/' + id)
      .catch(this.handleError);
  }

  obterStatusOcorrenciasHttp(): Observable<StatusOcorrencia[]> {
    return this._http.get(this._host + 'status/')
      .catch(this.handleError);
  }

  obterTipoOcorrenciaHttp(): Observable<TipoOcorrencia[]> {
    return this._http.get(this._host + 'tipo/')
      .catch(this.handleError);
  }

  atualizarOcorrenciaHttp(ocorrencia: Ocorrencia): Observable<HttpResponse<Ocorrencia>> {
    return this._http.put(this._host, ocorrencia, {
      observe: 'response'
    })
      .catch(this.handleError);
  }

  inserirComentarioOcorrenciaHttp(comentarioOcorrencia: ComentarioOcorrencia): Observable<HttpResponse<ComentarioOcorrencia>> {
    return this._http.post(this._host + 'comentario/', comentarioOcorrencia, {
      observe: 'response'
    })
      .catch(this.handleError);
  }

  obterOcorrenciasPorPeriodoHttp(filtroOcorrencia: FiltroOcorrencia): Observable<HttpResponse<Ocorrencia[]>> {
    return this._http.post(this._host + 'cliente/search/', filtroOcorrencia, {
      observe: 'response'
    }).catch(this.handleError);
  }

  obterOcorrenciasPorTipoHttp(filtroOcorrencia: FiltroOcorrencia): Observable<HttpResponse<ResultadoOcorrencias[]>> {
    return this._http.post(this._host + 'tipo/search/', filtroOcorrencia, {
      observe: 'response'
    }).catch(this.handleError);
  }

  obterOcorrenciasPorStatusHttp(filtroOcorrencia: FiltroOcorrencia): Observable<HttpResponse<ResultadoOcorrencias[]>> {
    return this._http.post(this._host + 'status/search/', filtroOcorrencia, {
      observe: 'response'
    }).catch(this.handleError);
  }

  obterOcorrenciasPorPontoFisicoHttp(filtroOcorrencia: FiltroOcorrencia): Observable<HttpResponse<ResultadoOcorrencias[]>> {
    return this._http.post(this._host + 'ponto-fisico/search/', filtroOcorrencia, {
      observe: 'response'
    }).catch(this.handleError);
  }

  obterOcorrenciasBaixaUsuario(id: number): Observable<Ocorrencia[]> {
    return this._http.get(this._host + 'usuario/' + id)
      .catch(this.handleError);
  }

  obterOcorrenciasPorPontoFisicoGraficoHttp(filtroOcorrencia: FiltroOcorrencia): Observable<HttpResponse<Ocorrencia[]>> {
    return this._http.post(this._host + 'ponto-fisico-grafico/search/', filtroOcorrencia, {
      observe: 'response'
    }).catch(this.handleError);
  }

  obterOcorrenciasPorStatusGraficoHttp(filtroOcorrencia: FiltroOcorrencia): Observable<HttpResponse<Ocorrencia[]>> {
    return this._http.post(this._host + 'status-grafico/search/', filtroOcorrencia, {
      observe: 'response'
    }).catch(this.handleError);
  }

  obterOcorrenciasPorTipoGraficoHttp(filtroOcorrencia: FiltroOcorrencia): Observable<HttpResponse<Ocorrencia[]>> {
    return this._http.post(this._host + 'tipo-grafico/search/', filtroOcorrencia, {
      observe: 'response'
    }).catch(this.handleError);
  }

  obterOcorrenciasPorDiaGraficoHttp(filtroOcorrencia: FiltroOcorrencia): Observable<HttpResponse<Ocorrencia[]>> {
    return this._http.post(this._host + 'dia-grafico/search/', filtroOcorrencia, {
      observe: 'response'
    }).catch(this.handleError);
  }

  obterOcorrenciasPorPontoFisicoDiariaHttp(filtroOcorrencia: FiltroOcorrencia): Observable<HttpResponse<ResultadoOcorrenciaDiaria[]>> {
    return this._http.post(this._host + 'ocorrencias-diaria/search/', filtroOcorrencia, {
      observe: 'response'
    }).catch(this.handleError);
  }

  obterControleOcorrenciaAutoHttp(id: number): Observable<ControleOcorrenciaAuto> {
    return this._http.get(this._host + 'controle-ocorrencia/' + id)
      .catch(this.handleError);
  }

  obterReincidenciaOcorrenciaHttp(idConfigOcorrenciaAuto: number): Observable<ReincidenciaOcorrencia> {
    return this._http.get(this._host + 'reincidencia-ocorrencia/' + idConfigOcorrenciaAuto)
      .catch(this.handleError);
  }


  cadastrarReincidenciaOcorrenciaHttp(reincidencia: ReincidenciaOcorrencia): Observable<HttpResponse<ReincidenciaOcorrencia>> {
    return this._http
      .post(this._host + 'reincidencia-ocorrencia/', reincidencia, {
        observe: 'response'
      })
      .catch(this.handleError);
  }


  atualizarReincidenciaOcorrenciaHttp(reincidencia: ReincidenciaOcorrencia): Observable<HttpResponse<ReincidenciaOcorrencia>> {
    return this._http
      .put(this._host + 'reincidencia-ocorrencia/', reincidencia, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  apagarReincidenciaOcorrenciaHttp(idReincidenciaOcorrencia: number): Observable<HttpResponse<ReincidenciaOcorrencia>> {
    return this._http.delete(this._host + 'reincidencia-ocorrencia/' + idReincidenciaOcorrencia)
      .catch(this.handleError);
  }

  cadastrarCriteriosReincidenciaOcorrenciaHttp(criterios: CriterioReincidenciaOcorrencia[]):
    Observable<HttpResponse<CriterioReincidenciaOcorrencia[]>> {
    return this._http
      .post(this._host + 'criterio-reincidencia-ocorrencia/', criterios, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  atualizarCriterioReincidenciaOcorrenciaHttp(criterio: CriterioReincidenciaOcorrencia):
    Observable<HttpResponse<CriterioReincidenciaOcorrencia>> {
    return this._http
      .put(this._host + 'criterio-reincidencia-ocorrencia/', criterio, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerCriteriosReincidenciaOcorrenciaHttp(criterios: CriterioReincidenciaOcorrencia[]):
    Observable<HttpResponse<CriterioReincidenciaOcorrencia[]>> {
    return this._http
      .patch(this._host + 'criterio-reincidencia-ocorrencia/', criterios, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterReincidenciasHttp(filtroReincidencia: FiltroReincidencia): Observable<HttpResponse<Reincidencia[]>> {
    return this._http.post(this._host + 'listar-reincidencias/search/', filtroReincidencia, {
      observe: 'response'
    }).catch(this.handleError);
  }

  enviarEmailOcorrenciaHttp(email: EmailOcorrencia): Observable<HttpResponse<EmailOcorrencia>> {
    return this._http.post(this._host + 'enviar-email-ocorrencia/', email, {
      observe: 'response'
    }).catch(this.handleError);
  }

  private handleError(error: Response) {

    console.error(error);

    return Observable.throw(error.json().error || 'Server error');

  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/ocorrencias/ocorrencias.service.ts